import moment from 'moment';

/**
* Locates and scrolls to the heading matching the provided moment
*/
export function scrollToHeading(date: moment.Moment, month?: boolean) {
    const prefix = month ? `Month-List` : `List-Day`;

    var headingId = `${prefix}-${date.startOf('day').format('X')}`;
    const heading = document.getElementById(headingId) as HTMLHeadingElement;

    /* We want to prevent the page from jumping on initial load here.
    In most browsers, we can test if the current activeElement is not the body
    but in all Mac OS, desktop + iOS, and all browsers, when you click a <button>,
    the focus is put back on the <body>. So there's 'data-untouched' on the entry
    now, and it gets removed after scrollToHeading has its first touch.
    So this is a quick hack but there's a reason! */
    const entry = document.querySelector('[data-untouched]');
    if (heading && entry) {
        const testTouched = entry.getAttribute('data-untouched');
        if (testTouched != "true") {
            heading.setAttribute('tabindex', '0');
            const blur = () => {
                heading.removeAttribute('tabindex');
                heading.removeEventListener('blur', blur);
            }
            heading.addEventListener('blur', blur);
            heading.focus();
            //window.scrollTo(0, heading.offsetTop);
        }
        else {
            entry.setAttribute('data-untouched', 'false');
        }
    }
}